<template>
  <ion-page>
    <main-header></main-header>
    <ion-content padding>
      <ion-list>
        <ion-item-divider>
          <ion-label>
            Need Help?
          </ion-label>
        </ion-item-divider>
        <ion-item
          href="mailto:info@stayseatedinc.net"
          detail
          data-cy="need-help-link"
        >
          <ion-avatar slot="start">
            <img :src="logo" />
          </ion-avatar>
          <ion-label>
            <p>
              Contact us at
              <strong>
                info@stayseatedinc.net
              </strong>
            </p>
          </ion-label>
        </ion-item>
        <template v-if="user">
          <ion-item-divider>
            <ion-label>
              You are signed in as
            </ion-label>
          </ion-item-divider>
          <ion-item>
            <ion-avatar slot="start">
              <img v-if="isSignInEmail" src="./email.svg" />
              <img v-else-if="isSignInGoogle" src="./google.svg" />
              <img v-else-if="isSignInFacebook" src="./facebook.svg" />
              <img v-else-if="isSignInApple" src="./apple.svg" />
            </ion-avatar>
            <ion-label>
              <p>
                Email: <strong>{{ email }}</strong>
              </p>
            </ion-label>
            <ion-button
              slot="end"
              color="danger"
              @click="handleSignOut()"
              data-cy="sign-out-button"
            >
              Sign Out
            </ion-button>
          </ion-item>
        </template>
        <ion-item v-else>
          <ion-label>
            Stay Seated is even better when you have an account.
          </ion-label>
          <ion-button
            slot="end"
            color="success"
            @click="handleSignUp()"
            data-cy="sign-up-button"
          >
            Sign Up
          </ion-button>
        </ion-item>
        <ion-item v-if="role">
          <ion-avatar v-if="user" slot="start">
            <img :src="user.photoURL" />
          </ion-avatar>
          <ion-label>
            <p>
              You have the role:
              <strong>
                {{ role }}
              </strong>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
    <available-order-footer v-if="canShowFooter"></available-order-footer>
  </ion-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import logo from "@/assets/images/logo.png";
import PlatformService from "@/services/Platform";

export default {
  title: "Support and Contact",

  data: function() {
    return {
      logo
    };
  },

  computed: {
    ...mapGetters("auth", [
      "user",
      "userIsAdmin",
      "userIsRunner",
      "userIsVendor"
    ]),

    canShowFooter() {
      return PlatformService.isMobile();
    },

    isSignInEmail() {
      return (
        this.user &&
        this.user.providerData[0].providerId ===
          this.$auth.EmailAuthProvider.PROVIDER_ID
      );
    },

    isSignInGoogle() {
      return (
        this.user &&
        this.user.providerData[0].providerId ===
          this.$auth.GoogleAuthProvider.PROVIDER_ID
      );
    },

    isSignInFacebook() {
      return (
        this.user &&
        this.user.providerData[0].providerId ===
          this.$auth.FacebookAuthProvider.PROVIDER_ID
      );
    },

    isSignInApple() {
      return this.user && this.user.providerData[0].providerId === "apple.com";
    },

    email() {
      return this.user && this.user.email;
    },

    role() {
      let role = "";

      if (this.userIsAdmin) {
        role = "Admin";
      } else if (this.userIsRunner) {
        role = "Runner";
      } else if (this.userIsVendor) {
        role = "Vendor";
      }

      return role;
    }
  },

  methods: {
    ...mapActions("auth", ["signOut"]),

    handleSignOut() {
      this.signOut().then(() => {
        this.$router.push("/").catch(e => e);
      });
    },

    handleSignUp() {
      this.$router.push({ name: "Sign Up" }).catch(e => e);
    }
  }
};
</script>
